import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  currentLanguage: string = 'ar';

  constructor(private translate: TranslateService) {
    this.translate.onLangChange.subscribe(data => {
      if (data.lang == 'ar') {
        this.currentLanguage = 'ar';
      } else {
        this.currentLanguage = 'en';
      }
    })
  }

  ngOnInit() {
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

}
